import { Card } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite';
import { Permit, Vehicle } from '../../../app/models/permit';

interface Props {
    vehicle: Vehicle,
    permit: Permit
}

export default observer(function VehicleCardContent({ 
    vehicle,
    permit
}: Props) {
    return (
        <>
            <Card.Content>
                <Card.Header>{`${vehicle.year} ${vehicle.make}`}</Card.Header>
                <Card.Meta style={{fontSize: '1.2em'}}>
                    {vehicle.model}
                </Card.Meta>
                <Card.Description style={{fontSize: '1.2em'}}>
                    {vehicle.licensePlateNbr}
                </Card.Description>
            </Card.Content>
            {permit.permitTypeId === 3 &&
                <Card.Content extra>
                    HOV Number: {vehicle.hovTransitVehicleNbr}<br />
                    Transit Agency: {vehicle.transitAgency}
                </Card.Content>
            }
        </>
    )
})